import React, { Component } from "react";
import { connect } from "react-redux";
import { Breadcrumb, Modal } from "react-bootstrap";
import Select from "react-select";
import $ from "jquery";
import Spinner from "react-bootstrap/Spinner";
import {
  Button,
  FormGroup,
  Input,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";

class delegate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referenceNo: "",
      delegate: false,
      advDelegate: false,
      approverId: "",
      maxdays: "",
      fromdate: "",
      todate: "",
      delegateList: [],
      sectionListArray: [],
      delegatePopup: false,
      RequesterSection: "",
      deligateRequesterSection: "",
      RequesterDepartment: "",
      deligateRequesterDepartment: "",
      RequesterDivision: "",
      deligateRequesterDivision: "",
      RequesterDesignation: "",
      deligateRequesterDesignation: "",
      showFirstStaffPopup: "",
      getEmployeeFirstShow: false,
      deligategetEmployeeFirstShow: false,
      RequesterDisplayName: "",
      deligateRequesterDisplayName: "",
      deligatepopupEmployeeName: "",
      deligatepopupSection: 0,
      deligateStaffDetailslistArray: [],
      canStafNamePopover: "",
      section: "",
      deligateSection: "",
      StaffDetailslistArray: [],
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      stafflistArraySpin: "none",
      StaffDetailslistArraySpin: "none",
      RequesterId: "",
      RequesterName: "",
      RequesterSectionName: "",
      RequesterDepartment: "",
      RequesterDivision: "",
      RequesterDesignation: "",
      canStafNamePopover: "flex",
      deligateRequesterId: "",
      deligateRequesterName: "",
      deligateRequesterSection: "",
      deligateRequesterSectionName: "",
      deligateRequesterDepartment: "",
      deligateRequesterDivision: "",
      deligateRequesterDesignation: "",
      deligatecanStafNamePopover: "flex",
      deligatepopupEmployeeId: "",
      deligatestafflistArraySpin: "",
      delegationArray: [],
      all: false,
      dateError: false,
      orgId: "",
      orgName: "",
    };
  }

  componentDidMount() {
    $("#StafNamePopover").popover({ html: true });
    this.props.dispatch({ type: "headerTitle", value: "Create Request" });
    this.props.dispatch({ type: "Referenceno", value: "" });
    this.SectionListData();
  }

  getDelegation = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Admin/GetPendingeDocforDelegation?ReferenceNo=${
            this.state.referenceNo
          }&ApproverId=${
            this.state.RequesterId ? parseInt(this.state.RequesterId) : ""
          }`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              delegateList: data.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  showFirstStaffPopup = () => {
    this.setState({ getEmployeeFirstShow: true });
  };

  deligateshowFirstStaffPopup = () => {
    this.setState({ deligategetEmployeeFirstShow: true });
  };

  SectionListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/SectionDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              sectionListArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  searchEmployeeClear = () => {
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      section: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  deligatesearchEmployeeClear = () => {
    this.setState({
      deligatepopupEmployeeId: "",
      deligatepopupEmployeeName: "",
      deligatepopupSection: 0,
      deligateSection: "",
      deligateStaffDetailslistArray: [],
      deligatestafflistArraySpin: "none",
    });
  };

  searchEmployee = () => {
    try {
      this.setState({ StaffDetailslistArraySpin: "" });
      let postData = {
        employeeId: this.state.popupEmployeeId,
        name: this.state.popupEmployeeName,
        section: this.state.section.value,
        employeeType: "",
      };

      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ StaffDetailslistArray: data.resultObject });
            this.setState({ StaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  deligateSearchEmployee = () => {
    try {
      let postData = {
        employeeId: this.state.deligatepopupEmployeeId,
        name: this.state.deligatepopupEmployeeName,
        section: this.state.deligateSection.value,
        employeeType: "",
      };

      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ deligateStaffDetailslistArray: data.resultObject });
            this.setState({ StaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };
  getStaffDetails = (
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation
  ) => {
    this.setState({
      RequesterId: id,
      RequesterName: name,
      RequesterSection: section,
      RequesterSectionName: sectionName,
      RequesterDepartment: department,
      RequesterDivision: division,
      RequesterDesignation: designation,
      canStafNamePopover: "flex",
      getEmployeeFirstShow: false,
      RequesterDisplayName: id + " - " + name,
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
    });
  };

  deligateGetStaffDetails = (
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation
  ) => {
    this.setState({
      deligateRequesterId: id,
      deligateRequesterName: name,
      deligateRequesterSection: section,
      deligateRequesterSectionName: sectionName,
      deligateRequesterDepartment: department,
      deligateRequesterDivision: division,
      deligateRequesterDesignation: designation,
      deligatecanStafNamePopover: "flex",
      deligategetEmployeeFirstShow: false,
      deligateRequesterDisplayName: id + " - " + name,
      deligatepopupEmployeeId: "",
      deligatepopupEmployeeName: "",
      deligatepopupSection: 0,
      deligateStaffDetailslistArray: [],
    });
  };

  allDeligation = () => {
    let tempValue = [];
    if (this.state.all) {
      this.state.delegateList?.map((value) =>
        tempValue.push(value.referenceNo)
      );
      this.setState({ delegationArray: [], all: false });
    } else {
      this.state.delegateList?.map((value) =>
        tempValue.push(value.referenceNo)
      );
      this.setState({ delegationArray: tempValue, all: true });
    }
  };

  changeDelegate = () => {
    try {
      let tempData = this.state.delegationArray.join(",");
      const postData = {
        originalapproverid: parseInt(
          this.state.RequesterId ? this.state.RequesterId : this.state.orgId
        ),
        originalapprovername: this.state.RequesterName
          ? this.state.RequesterName
          : this.state.orgName,
        delegatetoempid: this.state.deligateRequesterId,
        createdby: this.props.UserId,
        createdbyname: this.props.userName,
        delegatetoname: this.state.deligateRequesterName,
        fromdate: this.state.fromdate ? this.state.fromdate : null,
        todate: this.state.todate ? this.state.todate : null,
        typeofMode: this.state.deligateRequesterDisplayName
          ? "Approver"
          : "ReferenceNo",
        referenceno: tempData ? tempData : this.state.referenceNo,
        maxdays: this.state.maxdays ? this.state.maxdays : 0,
        mode: "Add",
      };

      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/Admin/InsertUpdateDelegation",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            window.location = process.env.REACT_APP_ENV + "/delegation/list";
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  toDate = (value) => {
    if (this.state.fromdate) {
      let date1 = new Date(this.state.fromdate).getTime();
      let date2 = new Date(value).getTime();
      if (date1 < date2) {
        this.setState({ todate: value, dateError: false });
      } else if (date1 > date2) {
        this.setState({ dateError: true });
      } else {
        this.setState({ dateError: true });
      }
    }
  };

  clearDelegate = () => {
    this.setState({ delegate: false });
  };

  clearAdvDelegate = () => {
    this.setState({ advDelegate: false });
  };

  hideFirstStaffPopup = () => {
    this.setState({
      popupEmployeeId: "",
      getEmployeeFirstShow: false,
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
    });
  };

  resetHandler = () => {
    this.setState({
      RequesterId: "",
      referenceNo: "",
      RequesterName: "",
      RequesterSection: "",
      RequesterSectionName: "",
      RequesterDepartment: "",
      RequesterDivision: "",
      RequesterDesignation: "",
      canStafNamePopover: "flex",
      getEmployeeFirstShow: false,
      RequesterDisplayName: "",
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: 0,
      StaffDetailslistArray: [],
      delegateList: [],
      delegationArray: [],
    });
  };

  deligatehideFirstStaffPopup = () => {
    this.setState({
      deligatepopupEmployeeId: "",
      deligategetEmployeeFirstShow: false,
      deligatepopupEmployeeName: "",
      deligatepopupSection: 0,
      deligateGetStaffDetails: [],
    });
  };

  delegationArray = (value, e) => {
    let data = [...this.state.delegationArray];

    if (e === true) {
      this.setState({
        orgId: value.oriApproverID,
        orgName: value.oriApproverName,
      });

      data.push(value.referenceNo);
    } else {
      if (data.length === 1) {
        data = [];
      } else {
        let finalData = [];
        data.map((dt) => dt !== value.referenceNo && finalData.push(dt));
        data = finalData;
      }
    }

    this.setState({ delegationArray: data, all: false });
  };

  render() {
    let SectionTypeOptionList = [];
    if (this.state.sectionListArray?.length > 0) {
      this.state.sectionListArray?.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.code,
        };
        SectionTypeOptionList.push(sData);
        return null;
      });
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item
            href={process.env.REACT_APP_ENV + "/delegation/list"}>
            Delegation
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Delegate</Breadcrumb.Item>
        </Breadcrumb>
        <Modal show={this.state.getEmployeeFirstShow} size="xl">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      name="popupEmployeeId"
                      value={this.state.popupEmployeeId}
                      onChange={(e) =>
                        this.setState({
                          popupEmployeeId: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="popupEmployeeName"
                      value={this.state.popupEmployeeName}
                      onChange={(e) =>
                        this.setState({ popupEmployeeName: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={SectionTypeOptionList}
                      value={this.state.section}
                      onChange={(value) => this.setState({ section: value })}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={this.searchEmployeeClear}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>

            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray?.map((staff, index) => (
                      <tr
                        className="cursor-pointer"
                        onClick={() =>
                          this.getStaffDetails(
                            staff.employeeId,
                            staff.name,
                            staff.section,
                            staff.sectionName,
                            staff.department,
                            staff.division,
                            staff.designation
                          )
                        }>
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.employeeId} </td>
                        <td> {staff.name} </td>
                        <td> ({staff.account}) </td>
                        <td> {staff.email} </td>
                        <td> {staff.section} </td>
                        <td> {staff.sectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray?.length <= 0 &&
                    this.state.StaffDetailslistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.StaffDetailslistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.hideFirstStaffPopup()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.deligategetEmployeeFirstShow} size="xl">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      name="deligatepopupEmployeeId"
                      value={this.state.deligatepopupEmployeeId}
                      onChange={(e) =>
                        this.setState({
                          deligatepopupEmployeeId: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="deligatepopupEmployeeName"
                      value={this.state.deligatepopupEmployeeName}
                      onChange={(e) =>
                        this.setState({
                          deligatepopupEmployeeName: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={SectionTypeOptionList}
                      value={this.state.deligateSection}
                      onChange={(value) =>
                        this.setState({ deligateSection: value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={this.deligatesearchEmployeeClear}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.deligateSearchEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>

            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.deligateStaffDetailslistArray?.map(
                      (staff, index) => (
                        <tr
                          className="cursor-pointer"
                          onClick={() =>
                            this.deligateGetStaffDetails(
                              staff.employeeId,
                              staff.name,
                              staff.section,
                              staff.sectionName,
                              staff.department,
                              staff.division,
                              staff.designation
                            )
                          }>
                          <td>
                            {" "}
                            <p>
                              {" "}
                              <span className="material-icons-outlined select-employee-icon">
                                {" "}
                                how_to_reg{" "}
                              </span>{" "}
                            </p>{" "}
                          </td>
                          <td> {staff.employeeId} </td>
                          <td> {staff.name} </td>
                          <td> ({staff.account}) </td>
                          <td> {staff.email} </td>
                          <td> {staff.section} </td>
                          <td> {staff.sectionName} </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.deligateStaffDetailslistArray?.length <= 0 &&
                    this.state.deligateStaffDetailslistArray === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.StaffDetailslistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.deligatehideFirstStaffPopup()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="content-area">
          <section className="view-taskpending-section">
            <div className="form-group mb-4">
              <h5>Delegate</h5>
            </div>
          </section>

          <section className="view-taskpending-section">
            <div className="form-group row mb-0">
              <label for="" className="col-sm-2 requester-info  col-form-label">
                Reference Number
              </label>
              <div className="col-sm-5" style={{ marginLeft: "-7px" }}>
                <FormGroup>
                  <Input
                    value={this.state.referenceNo}
                    onChange={(e) =>
                      this.setState({ referenceNo: e.target.value })
                    }
                    type="text"
                  />
                </FormGroup>
                <br />
                <p className="text-center" style={{ color: "#707070" }}>
                  Or
                </p>
              </div>
            </div>
            <div className="row mb-0"></div>
            <div className="form-group row">
              <label for="" className="col-sm-2 col-form-label text-muted">
                <span style={{ display: "flex" }}>
                  Staff No / Name(Approver)
                </span>
              </label>
              <div className="col-sm-4">
                <div className="input-group mb-2 mr-sm-2">
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    placeholder=""
                    readOnly={true}
                    value={this.state.RequesterDisplayName}
                    onClick={this.showFirstStaffPopup}
                  />
                  <div
                    className="input-group-prepend"
                    onClick={this.showFirstStaffPopup}>
                    <div className="input-group-text">
                      <i className="fa fa-search text-muted"> </i>
                    </div>
                  </div>
                  <div
                    className="input-group-prepend ml-3"
                    style={{ display: this.state.canStafNamePopover }}>
                    <button
                      id="PopoverLegacy"
                      className="input-group-text"
                      type="button"
                      data-toggle="popover"
                      data-placement="bottom">
                      <i className="fa fa-info text-muted"> </i>
                    </button>
                  </div>
                </div>

                <UncontrolledPopover
                  trigger="legacy"
                  placement="bottom"
                  target="PopoverLegacy">
                  <PopoverHeader></PopoverHeader>
                  <PopoverBody>
                    <div class="pop">
                      <div class="row">
                        <div class="col-xs-4 col-md-4">Section</div>
                        <div class="col-xs-8 col-md-8">
                          : {this.state.RequesterSection}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-4 col-md-4">Department</div>
                        <div class="col-xs-8 col-md-8">
                          : {this.state.RequesterDepartment}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-4 col-md-4">Division</div>
                        <div class="col-xs-8 col-md-8">
                          : {this.state.RequesterDivision}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-4 col-md-4">Designation</div>
                        <div class="col-xs-8 col-md-8">
                          : {this.state.RequesterDesignation}
                        </div>
                      </div>
                    </div>
                  </PopoverBody>
                </UncontrolledPopover>
              </div>
            </div>
            <div className="form-group row mb-0">
              <label
                for=""
                className="col-sm-2 requester-info  col-form-label"></label>
              <div className="col-sm-5">
                <div className="delegate-button-style">
                  <Button
                    onClick={this.resetHandler}
                    className="child-comments"
                    outline
                    color="primary">
                    Reset
                  </Button>
                  <Button
                    disabled={
                      this.state.referenceNo || this.state.RequesterId
                        ? false
                        : true
                    }
                    onClick={this.getDelegation}
                    className="child-comments"
                    color="primary">
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </section>
          <section className="view-taskpending-section">
            <div className="form-group row mb-0 mt-4">
              <div className="comments-button-style mb-2">
                <Button
                  disabled={
                    (this.state.delegateList?.length &&
                      this.state.delegationArray.join(",")) ||
                    (this.state.referenceNo &&
                      (this.state.RequesterName || this.state.orgName))
                      ? false
                      : true
                  }
                  onClick={() => this.setState({ advDelegate: true })}
                  className="child-comments"
                  outline
                  color="primary">
                  Advance Delegate
                </Button>
                <Button
                  disabled={
                    (this.state.delegateList?.length &&
                      this.state.delegationArray.join(",")) ||
                    (this.state.referenceNo &&
                      (this.state.RequesterName || this.state.orgName))
                      ? false
                      : true
                  }
                  onClick={() => this.setState({ delegate: true })}
                  className="child-comments"
                  color="primary">
                  Delegate
                </Button>
              </div>
            </div>
            <Modal show={this.state.delegate}>
              <Modal.Header>
                <h5>Delegate To</h5>
              </Modal.Header>
              <Modal.Body>
                <label>Employee ID / Name</label>
                <div>
                  <div className="input-group mb-2 mr-sm-2">
                    <input
                      type="text"
                      className="form-control"
                      id=""
                      placeholder=""
                      readOnly={true}
                      value={this.state.deligateRequesterDisplayName}
                      onClick={this.deligateshowFirstStaffPopup}
                    />
                    <div
                      className="input-group-prepend"
                      onClick={this.deligateshowFirstStaffPopup}>
                      <div className="input-group-text">
                        <i className="fa fa-search text-muted"> </i>
                      </div>
                    </div>
                  </div>
                </div>
                <label>Max Days</label>
                <div>
                  <div className="col-sm-3">
                    <div className="input-group mb-2 mr-sm-2">
                      <Input
                        onChange={(e) =>
                          this.setState({
                            maxdays: parseInt(
                              e.target.value > 0 ? e.target.value : 0
                            ),
                          })
                        }
                        min="0"
                        class="noscroll"
                        type="number"
                      />
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="text-right">
                  <Button onClick={this.clearDelegate} color="primary" outline>
                    Cancel
                  </Button>
                  <Button
                    onClick={this.changeDelegate}
                    color="primary"
                    className=" ml-3">
                    Change
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
            <Modal show={this.state.advDelegate}>
              <Modal.Header>
                <h5>Advance Delegate To</h5>
              </Modal.Header>
              <Modal.Body>
                <label>Employee ID / Name</label>
                <div>
                  <div className="input-group mb-2 mr-sm-2">
                    <input
                      type="text"
                      className="form-control"
                      id=""
                      placeholder=""
                      readOnly={true}
                      value={this.state.deligateRequesterDisplayName}
                      onClick={this.deligateshowFirstStaffPopup}
                    />
                    <div
                      className="input-group-prepend"
                      onClick={this.deligateshowFirstStaffPopup}>
                      <div className="input-group-text">
                        <i className="fa fa-search text-muted"> </i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <label>From date</label>
                    <div className="form-group row">
                      <div className="col-sm-10">
                        <input
                          onChange={(e) =>
                            this.setState({ fromdate: e.target.value })
                          }
                          type="date"
                          className="form-control"
                          id=""
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <label>To date</label>
                    <div className="form-group row">
                      <div className="col-sm-10">
                        <input
                          onChange={(e) => this.toDate(e.target.value)}
                          type="date"
                          value={this.state.todate}
                          className="form-control"
                        />
                        {this.state.dateError && (
                          <p style={{ fontSize: "12px", color: "red" }}>
                            Must be greater than from date*
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="text-right">
                  <Button
                    onClick={this.clearAdvDelegate}
                    color="primary"
                    outline>
                    Cancel
                  </Button>
                  <Button
                    onClick={this.changeDelegate}
                    color="primary"
                    className=" ml-3">
                    Change
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
            <div className="customized-table">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col">
                        <input
                          checked={this.state.all}
                          onClick={this.allDeligation}
                          type="checkbox"
                        />
                      </th>
                      <th scope="col">Reference No</th>
                      <th scope="col">Employee</th>
                      <th scope="col"> eDoc Type </th>
                      <th scope="col">Submitted Date </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.delegateList?.length
                      ? this.state.delegateList?.map((dt) => (
                          <tr>
                            <th scope="col">
                              <input
                                type="checkbox"
                                checked={this.state.delegationArray.includes(
                                  dt.referenceNo
                                )}
                                onClick={(e) =>
                                  this.delegationArray(dt, e.target.checked)
                                }
                              />
                            </th>
                            <td>{dt.referenceNo}</td>
                            <td>{dt.employee}</td>
                            <td>{dt.eDocType}</td>
                            <td>{dt.createdDate}</td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </table>
                {this.state.delegateList?.length == 0 && (
                  <div>
                    <p className="text-center">
                      Sorry, there is no matching data to display
                    </p>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};
export default connect(mapStateToProps)(delegate);
